<div *ngIf="!hasSelectedEquipment">
  <input
    class="input-legacy"
    type="text"
    placeholder="{{ 'MAINTENANCES.EQUIPMENT_PLACEHOLDER' | translate }}"
    [matAutocomplete]="auto"
    [(formControl)]="inputValue"
  />

  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="setSelectedEquipment()">
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
    <mat-option *ngFor="let equipment of equipments" [value]="equipment.id">
      {{ equipment.name }}
    </mat-option>
    <mat-option *ngIf="!equipments.length">
      {{ 'MAINTENANCES.EQUIPMENT_NOT_FOUND' | translate }}
    </mat-option>
  </mat-autocomplete>
</div>

<div class="selected-input" *ngIf="hasSelectedEquipment">
  <input class="input-legacy" type="text" disabled [value]="selectedEquipment.name" />

  <button
    mat-icon-button
    class="cancel-button accent-700-fg"
    *ngIf="hasSelectedEquipment"
    (click)="deselectEquipment()"
  >
    <mat-icon>cancel</mat-icon>
  </button>
</div>
